// extracted by css-extract-rspack-plugin
export default {"resize-handle":"resize-handle-GnfKLg","resizeHandle":"resize-handle-GnfKLg","active":"active-Fsqx3a"};